import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import {
  MrfiktivInvoiceAggregationViewModelGen,
  MrfiktivInvoiceTotalsByCurrencyViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
class InvoiceTotalsByCurrencyBase implements MrfiktivInvoiceTotalsByCurrencyViewModelGen {
  /**
   * Currency code
   * @example EUR
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceTotalsByCurrency.currency"
  })
  currency: string;

  /**
   * Total amount of all invoices for this currency
   * @example 188.12
   */
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.invoiceTotalsByCurrency.total"
  })
  total: number;

  /**
   * Sub total amount of all invoices for this currency
   * @example 164.68
   */
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.invoiceTotalsByCurrency.subtotal"
  })
  subtotal: number;

  /**
   * Total tax amount of all invoices for this currency
   * @example 23.44
   */
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.invoiceTotalsByCurrency.taxtotal"
  })
  taxtotal: number;

  constructor(invoiceTotalsByCurrency?: Partial<MrfiktivInvoiceTotalsByCurrencyViewModelGen>) {
    this.currency = invoiceTotalsByCurrency?.currency || "";
    this.total = invoiceTotalsByCurrency?.total || 0;
    this.subtotal = invoiceTotalsByCurrency?.subtotal || 0;
    this.taxtotal = invoiceTotalsByCurrency?.taxtotal || 0;
  }
}

type IInvoiceTotalsByCurrency = InvoiceTotalsByCurrencyBase;
const InvoiceTotalsByCurrency = Filter.createForClass(InvoiceTotalsByCurrencyBase);

@IsFilterable
class InvoiceAggregationBase implements MrfiktivInvoiceAggregationViewModelGen {
  /**
   * Total number of invoices across all currencies
   */
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.invoiceAggregation.count"
  })
  count?: number;

  /**
   * Array of totals by currency
   */
  @FilterConfig({
    type: InvoiceTotalsByCurrency,
    displayName: "objects.invoiceAggregation.totals"
  })
  totals?: MrfiktivInvoiceTotalsByCurrencyViewModelGen[];

  constructor(invoiceAggregation?: Partial<MrfiktivInvoiceAggregationViewModelGen>) {
    this.count = invoiceAggregation?.count;
    this.totals = invoiceAggregation?.totals?.map(total => new InvoiceTotalsByCurrencyBase(total));
  }
}

type IInvoiceAggregation = InvoiceAggregationBase;
const InvoiceAggregation = Filter.createForClass(InvoiceAggregationBase);

export { IInvoiceTotalsByCurrency, InvoiceTotalsByCurrency, IInvoiceAggregation, InvoiceAggregation };
